// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"5109":"echarts-gl","5553":"echarts-core"}[chunkId] || chunkId) + "/" + ({"5109":"echarts-gl","5553":"echarts-core"}[chunkId] || chunkId) + ".js";
};